module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content",
    staticStyle: {
      "padding-left": "0px",
      "padding-right": "0px"
    }
  }, [(_vm.noContentItem === 'yes' && !_vm.noContentErrorMsgItem) ? _c('div', {
    staticClass: "row"
  }, [_c('vue-content-loading', {
    attrs: {
      "width": 300,
      "height": 190
    }
  }, [_c('rect', {
    attrs: {
      "x": "0",
      "y": "0",
      "rx": "2",
      "ry": "2",
      "width": "25%",
      "height": "4"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "0",
      "y": "7",
      "rx": "4",
      "ry": "4",
      "width": "100%",
      "height": "150"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "0",
      "y": "160",
      "rx": "2",
      "ry": "2",
      "width": "100%",
      "height": "6"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "0",
      "y": "170",
      "rx": "2",
      "ry": "2",
      "width": "100%",
      "height": "4"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "0",
      "y": "177",
      "rx": "2",
      "ry": "2",
      "width": "100%",
      "height": "4"
    }
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.noContentErrorMsgItem) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
  }, [_c('router-link', {
    attrs: {
      "to": "/documents"
    }
  }, [_c('p', {
    staticClass: "sg-top"
  }, [_c('i', {
    staticClass: "fa fa-chevron-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("   " + _vm._s(_vm.getDataDoc.name))])])], 1)]) : _vm._e(), _vm._v(" "), (_vm.noContentErrorMsgItem) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
  }, [_c('div', {
    staticClass: "sg-str",
    on: {
      "click": function($event) {
        return _vm.favoritDocument(_vm.getDataDoc.id)
      }
    }
  }, [_c('i', {
    class: [_vm.getDataDoc.favourite == 'yes' ? 'fa fa-star' : 'fa fa-star-o'],
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('iframe', {
    staticStyle: {
      "border": "1px solid #CCC",
      "border-width": "1px",
      "margin-bottom": "5px",
      "max-width": "100%",
      "height": "700px"
    },
    attrs: {
      "src": 'https://smartapprcp.s3.ap-southeast-1.amazonaws.com/' + _vm.getDataDoc.url,
      "width": "100%",
      "height": "650",
      "frameborder": "0",
      "marginwidth": "0",
      "marginheight": "0",
      "scrolling": "no",
      "allowfullscreen": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "sg-pname"
  }, [_vm._v(_vm._s(_vm.getDataDoc.name))]), _vm._v(" "), _c('p', {
    staticClass: "sg-disco"
  }, [_vm._v(_vm._s(_vm.getDataDoc.description))])])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.getOthers.length != 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.getOthers.slice(0, 4)), function(doc) {
    return _c('div', {
      staticClass: "col-6 col-sm-6 col-md-3 col-lg-3 col-xl-3"
    }, [_c('div', {
      staticClass: "sg-str",
      on: {
        "click": function($event) {
          return _vm.favoritDocument(doc.id)
        }
      }
    }, [_c('i', {
      class: [doc.favourite == 'yes' ? 'fa fa-star' : 'fa fa-star-o'],
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('a', {
      attrs: {
        "href": _vm.$router.resolve({
          path: '/documents/single-dcument/' + doc.category_id + '/' + doc.id
        }).href
      }
    }, [_c('div', {
      staticClass: "v-boxx"
    }, [_c('div', {
      staticClass: "v-videoo"
    }, [_c('img', {
      staticClass: "doc-img",
      attrs: {
        "src": "https://smartapprcp.s3.ap-southeast-1.amazonaws.com/" + doc.thumbnail
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "v-content"
    }, [_c('p', {
      staticClass: "v-name two-line-overflow"
    }, [_vm._v(_vm._s(doc.name))]), _vm._v(" "), _c('p', {
      staticClass: "v-disc two-line-overflow"
    }, [_vm._v(_vm._s(doc.description))])])])])])
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.noContentItems === 'yes' && !_vm.noContentErrorMsgItems) ? _c('div', {
    staticClass: "row"
  }, [_c('vue-content-loading', {
    attrs: {
      "width": 300,
      "height": 100
    }
  }, [_c('rect', {
    attrs: {
      "x": "0",
      "y": "13",
      "rx": "4",
      "ry": "4",
      "width": "23%",
      "height": "50"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "0",
      "y": "66",
      "rx": "2",
      "ry": "2",
      "width": "23%",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "0",
      "y": "72",
      "rx": "2",
      "ry": "2",
      "width": "14%",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "0",
      "y": "78",
      "rx": "2",
      "ry": "2",
      "width": "23%",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "0",
      "y": "84",
      "rx": "2",
      "ry": "2",
      "width": "23%",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "25%",
      "y": "13",
      "rx": "4",
      "ry": "4",
      "width": "23%",
      "height": "50"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "25%",
      "y": "66",
      "rx": "2",
      "ry": "2",
      "width": "23%",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "25%",
      "y": "72",
      "rx": "2",
      "ry": "2",
      "width": "14%",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "25%",
      "y": "78",
      "rx": "2",
      "ry": "2",
      "width": "23%",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "25%",
      "y": "84",
      "rx": "2",
      "ry": "2",
      "width": "23%",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "51%",
      "y": "13",
      "rx": "4",
      "ry": "4",
      "width": "23%",
      "height": "50"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "51%",
      "y": "66",
      "rx": "2",
      "ry": "2",
      "width": "23%",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "51%",
      "y": "72",
      "rx": "2",
      "ry": "2",
      "width": "14%",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "51%",
      "y": "78",
      "rx": "2",
      "ry": "2",
      "width": "23%",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "51%",
      "y": "84",
      "rx": "2",
      "ry": "2",
      "width": "23%",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "77%",
      "y": "13",
      "rx": "4",
      "ry": "4",
      "width": "23%",
      "height": "50"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "77%",
      "y": "66",
      "rx": "2",
      "ry": "2",
      "width": "23%",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "77%",
      "y": "72",
      "rx": "2",
      "ry": "2",
      "width": "14%",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "77%",
      "y": "78",
      "rx": "2",
      "ry": "2",
      "width": "23%",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "77%",
      "y": "84",
      "rx": "2",
      "ry": "2",
      "width": "23%",
      "height": "3"
    }
  })])], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-15c505be"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/user/SingleDocument.vue
// module id = 2067
// module chunks = 1